import errorAlert from "../views/errors/errorAlert";
import axios from "axios";
import { decryptData } from "../utils/decrypt";

const BASE_URL = process.env.REACT_APP_API_URL;

export const getGlobalValues = async () => {
  try {
    const globalData = await axios.get(`${BASE_URL}/global/get-global-values`);
    const global = await decryptData(globalData);
    return global;
  } catch (error) {
    errorAlert(error);
  }
};
